import Api from "shared/service/api/api";

//actions
export const LOAD_INVOICE_LIST = "loadInvoiceList";

//mutations
export const SET_INVOICE_LIST = "setInvoiceList";

const state = {
  invoices: {
    list: [],
    page: 1,
    page_count: 1,
  },
};

const actions = {
  [LOAD_INVOICE_LIST]({ commit }, { page, filter }) {
    Api.admin.invoice
      .all(page, filter)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_INVOICE_LIST, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_INVOICE_LIST](state, data) {
    state.invoices = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
